import React from "react";
import { useQuery } from "@apollo/client";
import { GET_MY_AUTH } from "../graphql/queries";
import { COUPON_CONFIG } from "../constants/couponConstants";
import DashboardPage from "./DashboardPage";
import CouponProgressReportPage from "./CouponProgressReportPage";
import MyVisitorsPage from "./MyVisitorsPage";
import { LinearProgress, Box, Typography } from "@mui/material";

/**
 * For coupon event (eventId 5087644490):
 * - Admin: Dashboard = Coupon Progress Report.
 * - Attendee: Dashboard = My Visitors (coupon claim list), no filter panel, only search.
 * Otherwise show the standard Dashboard.
 */
export default function DashboardOrCouponPage() {
  const { data: authData, loading } = useQuery(GET_MY_AUTH);
  const isCouponEvent = authData?.eventId === COUPON_CONFIG.EVENT_ID;
  const isAdmin = authData?.me === "admin";

  if (loading) {
    return (
      <Box sx={{ p: 3 }}>
        <LinearProgress />
        <Typography sx={{ mt: 2 }}>Loading...</Typography>
      </Box>
    );
  }

  if (isCouponEvent && !isAdmin) {
    return <MyVisitorsPage />;
  }
  if (isCouponEvent && isAdmin) {
    return <CouponProgressReportPage />;
  }
  return <DashboardPage />;
}
